const ViewKPIsBy = {
  GROUP: "group",
  IMPORTANCE: "importance"
} as const;

const ALL = Object.values(ViewKPIsBy);

export default { ...ViewKPIsBy, ALL };
